import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import GameCenter from "../../components/game/GameCenter";
import usmlsaLogo from "../../assets/images/usmlsa_new.png";
import "../../assets/css/schedule-modal.css";

const PublicGameCenterSimple = () => {
  const { tournamentId, divisionId } = useParams();
  const [refreshTrigger] = useState(0);

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      {/* Header Section with Logo */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderBottom: "3px solid #0d6efd",
          padding: "2rem 0",
          marginBottom: "2rem",
        }}
      >
        <Container>
          <div className="text-center">
            {/* USMLSA Logo */}
            <img
              src={usmlsaLogo}
              alt="USMLSA Logo"
              style={{
                maxWidth: "200px",
                height: "auto",
                marginBottom: "1.5rem",
              }}
            />
            
            <h1 style={{ color: "#212529", fontWeight: "700", marginBottom: "0.5rem" }}>
              Tournament Schedule & Standings
            </h1>
            <p className="text-muted">Live Game Information</p>
          </div>
        </Container>
      </div>

      {/* Game Center Content */}
      <Container>
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            padding: "2rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <GameCenter
            tournamentId={parseInt(tournamentId)}
            divisionId={parseInt(divisionId)}
            token={null}
            refreshTrigger={refreshTrigger}
          />
        </div>
      </Container>

      {/* Footer */}
      <Container className="py-4 mt-5">
        <div className="text-center text-muted">
          <img
            src={usmlsaLogo}
            alt="USMLSA"
            style={{
              maxWidth: "120px",
              height: "auto",
              marginBottom: "1rem",
              opacity: 0.7,
            }}
          />
          <p className="mb-0">
            Powered by <strong>USMLSA</strong> Tournament Management System
          </p>
          <p className="mb-0 small">
            <a 
              href="https://usmlsa.com" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: "#6c757d", textDecoration: "none" }}
            >
              www.usmlsa.com
            </a>
          </p>
        </div>
      </Container>
    </div>
  );
};

export default PublicGameCenterSimple;